import {useDefault} from '../../common';
export class TrackingSession {
  sessionId: string;
  constructor(sessionData?: any) {
    const data = useDefault(sessionData, {});
    this.sessionId = useDefault(data.sessionId, '');
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/ensighten/tracking-session.model.ts